import React from 'react'
import styles from './video-embed.module.scss'

const VideoEmbed = ({ youtube, vimeo, title }) => {
  let url = ''

  if( youtube ) {
    url = `https://www.youtube.com/embed/${ youtube }`
  } else if( vimeo ) {
    url = `https://player.vimeo.com/video/${ vimeo }`
  } else {
    return ''
  }

  return (
    <div className={ styles.ratio }>
      <iframe
        className={ styles.video }
        title={ title }
        src={ url }
        frameBorder="0"
        allowFullScreen
      />
    </div>
  )
}

export default VideoEmbed